import PhoneArea from "components/PhonePreview/PhoneArea"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { formValueSelector } from "redux-form"

const PhonePreview = ({
  bgImage,
  bgColor,
  tileBg,
  font,
  fontColor,
  bubbleColor,
  iconColor,
  contacts = [],
  removeSearch,
}) => {
  const contactList = contacts.slice(0, 5).map((contact, index) => (
    <div
      key={contact?.id}
      style={{
        backgroundColor: tileBg,
        width: "90%",
        height: "70px",
        borderRadius: "5px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        marginLeft: "10px",
        marginTop: index === 0 ? "10px" : "20px",
        border: "1px solid #ccc",
        boxShadow: "0 0 5px #ccc",
      }}
    >
      <div
        style={{
          display: "flex",
          marginTop: "10px",
        }}
      >
        <img
          className="rounded-circle avatar-xs"
          src={
            contact?.profile_pic &&
            contact?.profile_pic?.file &&
            contact?.profile_pic?.file?.url
              ? contact?.profile_pic?.file?.url
              : "https://admin.dev.markedprivate.com/app/images/app_profile_placeholder.png"
          }
          style={{
            width: "40px",
            height: "40px",
            alignSelf: "center",
            marginLeft: "5px",
            borderRadius: "40px",
          }}
        />
        <span
          className="ms-2 mt-1"
          style={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            alignSelf: "center",
          }}
        >
          <p
            style={{
              margin: "0px",
              color: fontColor,
              fontSize: "11px",
              fontFamily: font,
            }}
          >
            <b>{contact?.contact?.name || ""}</b>
          </p>
          {contact?.contact?.title && (
            <p
              style={{
                color: fontColor,
                margin: "0px",
                fontSize: "11px",
                fontFamily: font,
              }}
            >
              {contact?.contact?.title}
            </p>
          )}
        </span>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "5px",
        }}
      >
        {(contact?.contact?.is_pm_displayed === 1 ||
          contact?.contact?.is_pm_displayed === true) && (
          <div
            style={{
              backgroundColor: bubbleColor,
              width: "25px",
              height: "25px",
              borderRadius: "15px",
              marginRight: "10px",
              cursor: "pointer",
            }}
          >
            <i
              className="mdi mdi-message-bulleted font-size-18 ms-1"
              style={{ color: iconColor === "1" ? "white" : "black" }}
            />
          </div>
        )}
        {(contact?.contact?.is_email_displayed === 1 ||
          contact?.contact?.is_email_displayed === true) && (
          <div
            style={{
              backgroundColor: bubbleColor,
              width: "25px",
              height: "25px",
              borderRadius: "10px",
              marginRight: "10px",
              cursor: "pointer",
            }}
          >
            <i
              className="mdi mdi-email font-size-18 ms-1"
              style={{ color: iconColor === "1" ? "white" : "black" }}
            />
          </div>
        )}
        {(contact?.contact?.is_phone_displayed === 1 ||
          contact?.contact?.is_phone_displayed === true) && (
          <div
            style={{
              backgroundColor: bubbleColor,
              width: "25px",
              height: "25px",
              borderRadius: "10px",
              marginRight: "10px",
              cursor: "pointer",
            }}
          >
            <i
              className="mdi mdi-phone font-size-18 ms-1"
              style={{ color: iconColor === "1" ? "white" : "black" }}
            />
          </div>
        )}
      </div>
    </div>
  ))

  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage?.editedImage})`,
          backgroundColor: bgColor,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
          boxShadow: bgImage?.editedImage
            ? "inset 0 0 0 500px rgb(0 0 0 / 75%)"
            : "",
          overflow: "hidden",
        }}
      >
        {!removeSearch && (
          <div
            style={{
              backgroundColor: "rgba(239, 239, 239, 0.6)",
              width: "90%",
              height: "30px",
              borderRadius: "2px",
              marginLeft: "10px",
              marginTop: "10px",
              padding: "3px",
            }}
          >
            <p className="mt-1">Search by name...</p>
          </div>
        )}
        {contactList}
      </div>
    </PhoneArea>
  )
}

const selector = formValueSelector(FORM_NAMES.CONTACT_US)

const mapStateToProps = state => ({
  bgImage: selector(state, "design.background.bgImage"),
  bgColor: selector(state, "design.background.bgColor"),
  tileBg: selector(state, "design.tile.bgColor"),
  font: selector(state, "design.tile.font"),
  fontColor: selector(state, "design.tile.fontColor"),
  bubbleColor: selector(state, "design.icon.bubbleColor"),
  iconColor: selector(state, "design.icon.iconColor"),
  contacts: selector(state, "add_contacts.contacts"),
  removeSearch: selector(state, "add_contacts.removeSearch"),
})

export default connect(mapStateToProps)(PhonePreview)
